<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  },
  created(){
    this.$store.dispatch("getSkin");
  }
}
</script>

<style>
#app {
  font-family: sans-serif;
  font-weight: bolder;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
